import React from 'react';
import './styles.css';
import NavBar from './NavBar';

const Contact = () => {
  return (
    <>
      {NavBar()}
      <div className="contact-wrapper">
        <div className="contact-container">
          <h1 className="contact-title">Get in Touch</h1>
          <p className="contact-seo-intro">
            Have a question about Pool Party Social Club? Need support with your experience or want to give us feedback? We're here to help.
            Whether you're experiencing issues with the app, curious about features, or reporting suspicious behavior, our team is ready to assist.
            Pool Party Social Club is committed to safe and meaningful connections, and your input helps us improve every day.
          </p>

          <p className="contact-subtitle">
            We'd love to hear from you. Whether it's feedback, feature requests, bug reports, or just to say hi — reach out anytime.
          </p>

          <div className="contact-card">
            <p className="contact-label">Email us at:</p>
            <a href="mailto:consolelog@consolelogllc.com" className="contact-email">
              consolelog@consolelogllc.com
            </a>
            <p className="contact-note">
              We typically respond within 24–48 hours. Thanks for helping us make Pool Party Social Club better!
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
